import { create } from 'zustand';
import { type components } from '../endpoint/Schema';
import { createJSONStorage, persist } from 'zustand/middleware';

type GetTenantSuccessResponse = components['schemas']['TenantInfoDto'];

interface ITenantStore extends GetTenantSuccessResponse {
  loading: boolean;

  setLoading: (loading: boolean) => void;
  setTenantConfig: (config: GetTenantSuccessResponse) => void;
  clearTenant: () => void;
}

const useTenantStore = create<ITenantStore>()(
  persist(
    (set) => ({
      loading: false,
      name: '',
      setLoading: (loading: boolean) => {
        set({ loading });
      },
      setTenantConfig: (config: GetTenantSuccessResponse) => {
        set({ ...config });
      },
      clearTenant: () => {
        set({
          loading: false,
          name: '',
          id: undefined,
          description: undefined,
          parentName: undefined,
          appApplicationId: undefined,
          appColors: undefined,
        });
      },
    }),
    {
      name: 'tenant-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export default useTenantStore;

export const selectTenantId = (state: ITenantStore) => {
  return state.id;
};

export const selectAppId = (state: ITenantStore) => {
  return state.appApplicationId;
};
